import { filterInterface as filterInterfaceRegistry } from '@ardoq/filter-interface';
// eslint-disable-next-line no-restricted-imports
import { filterInterface } from './filterInterface';

export const initializeFilterInterface = () =>
  filterInterfaceRegistry.registerImplementation(filterInterface);
